/*eslint-disable*/
import {
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from "@material-ui/core";
import NumberInput from "components/Wrappers/materialUIWrappers/components/NumberInput";
import { percentage } from "helpers/ValidationHelpers";
import React from "react";
import { Field } from "redux-form";

const colwidth = value => {
  return {
    width: value,
    minWidth: value,
    maxWidth: value
  };
};

const GroupBenefits = props => (
  <Table>
    <TableHead>
      <TableRow>
        <TableCell className="cellPaddingSmall" style={colwidth("15em")}>
          {"Retirement"}
        </TableCell>
        <TableCell className="cellPaddingSmall" style={colwidth("15em")}>
          {"Employee Contribution (%)"}
        </TableCell>
        <TableCell className="cellPaddingSmall" style={colwidth("15em")}>
          {"Employer Contribution (%)"}
        </TableCell>
        <TableCell className="cellPaddingSmall" style={colwidth("15em")}>
          {"Current Value (R)"}
        </TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      <TableRow>
        <TableCell className="cellPaddingSmall">
          <Typography>Provident Fund (if applicable)</Typography>
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              suffix="%"
              validate={[percentage]}
              checkValidation={props.checkValidation}
              name={`retirement_fund.retirement.provident_fund.employee_contribution`}
              label="Employee Contribution"
            />
          </FormControl>
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              suffix="%"
              validate={[percentage]}
              checkValidation={props.checkValidation}
              name={`retirement_fund.retirement.provident_fund.employer_contribution`}
              label="Employer Contribution"
            />
          </FormControl>
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              prefix="R"
              seperator=" "
              checkValidation={props.checkValidation}
              name={`retirement_fund.retirement.provident_fund.current_value`}
              label="Current Value"
            />
          </FormControl>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell className="cellPaddingSmall">
          <Typography>Pension Fund (if applicable)</Typography>
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              suffix="%"
              validate={[percentage]}
              checkValidation={props.checkValidation}
              name={`retirement_fund.retirement.pension_fund.employee_contribution`}
              label="Employee Contribution"
            />
          </FormControl>
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              suffix="%"
              validate={[percentage]}
              checkValidation={props.checkValidation}
              name={`retirement_fund.retirement.pension_fund.employer_contribution`}
              label="Employer Contribution"
            />
          </FormControl>
        </TableCell>
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              prefix="R"
              seperator=" "
              checkValidation={props.checkValidation}
              name={`retirement_fund.retirement.pension_fund.current_value`}
              label="Current Value"
            />
          </FormControl>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell className="cellPaddingSmall">
          <Typography>Annual Pensionable Income (if applicable)</Typography>
        </TableCell>
        <TableCell className="cellPaddingSmall" />
        <TableCell className="cellPaddingSmall" />
        <TableCell className="cellPaddingSmall">
          <FormControl fullWidth>
            <Field
              component={NumberInput}
              prefix="R"
              seperator=" "
              checkValidation={props.checkValidation}
              name={`retirement_fund.annual_pensionable_income`}
              label="Amount"
            />
          </FormControl>
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
);

export default GroupBenefits;



// WEBPACK FOOTER //
// ./src/views/Fna/steps/RetirementFund/components/Retirement.jsx